import { makeStyles } from '@material-ui/core/styles';
import { ERebrandingFonts } from 'helpers/constants';

export const useStyles = makeStyles((theme) => ({
  paper: {
    position: 'relative',
    padding: theme.spacing(8),
    fontFamily: ERebrandingFonts.OPENSANS,
    [theme.breakpoints.down('md')]: {
      paddingInline: theme.spacing(2),
    },
  },
  closeIconBtn: {
    position: 'absolute',
    top: 30,
    right: 30,
    color: '#0D47A1',
  },
}));
